module.exports = __webpack_public_path__ + "img/epasnets-comp-2.1c9c3667.webp";